var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoginEye = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Frame",
  clipPath: "url(#clip0_0_7)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M4.28793 4.34668C2.81209 5.26065 1.9539 6.57671 1.54442 7.35626C1.40284 7.62579 1.33205 7.76053 1.33203 8.00579C1.33201 8.25106 1.40259 8.38546 1.54376 8.65433C2.21778 9.93806 4.11004 12.68 7.97663 12.68C9.49563 12.68 10.71 12.2569 11.6654 11.6651",
  stroke: "#A69782",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M6.58579 6.58577C6.22386 6.94772 6 7.44772 6 7.99999C6 9.10459 6.8954 9.99999 8 9.99999C8.55227 9.99999 9.05227 9.77612 9.4142 9.41419",
  stroke: "#A69782",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M1.33203 1.33301L14.6654 14.6663",
  stroke: "#A69782",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M6.66797 3.43199C7.06357 3.36804 7.48397 3.33301 7.93037 3.33301C11.8511 3.33301 13.7698 6.03557 14.4532 7.30081C14.5964 7.56581 14.668 7.69834 14.668 7.94007C14.668 8.18187 14.596 8.31481 14.4523 8.58081C14.2465 8.96154 13.929 9.47201 13.4791 9.99967",
  stroke: "#A69782",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_0_7"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoginEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/login-eye.d241a7b5709f3f06db574d6bdd573549.svg";